import { action } from 'typesafe-actions';

import { User, UserTypes } from './types';

export const saveUserData = (data: User) =>
  action(UserTypes.SAVE_USER_DATA, { data });
